import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { Authorization } from "../model/RSS/Authorization.model";
import { RoleGuardService } from "../services/role-guard.service";

export const AuthorizationResolver: ResolveFn<Authorization> = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<Authorization> => {
    return inject(RoleGuardService).Authorization();
  };